import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'app/types';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state.eventLog || initialState;

export const selectEventLog = createSelector(
  [selectDomain],
  eventLogState => eventLogState,
);
